export default __webpack_public_path__ + "static/media/group-632@2x.44a23066.png";